import React from 'react'

import DangerouslySetInnerHtml from '../../../../shared/components/dangerouslySetInnerHtml'

const SearchPageArticle = ({ html, centre = false, wide = false }) => {
  if (!html) {
    return null
  }

  const alignment = centre ? 'centre' : 'right'
  const layoutWide = wide ? '-layout-wide' : ''

  return (
    <section className="page-section -color-grey-light -border-top -border-bottom">
      <div className="search-page-content-article__text-section">
        <div className={`grid-container ${layoutWide}`}>
          {!centre && (
            <div className="sidebar-s -size-fixed-tablet is-hidden-phone">
              <div className="search-page-content__sidebar-spacer" />
            </div>
          )}
          <div
            className={`content-l -size-scale-tablet content-${alignment} ${layoutWide}`}
          >
            <div className="fds-c-text-preformatted">
              <DangerouslySetInnerHtml>{html}</DangerouslySetInnerHtml>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SearchPageArticle
